import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { OrderDetailMapper } from '@data/data/adapters/order-detail/order-detail.adapter';
import { PaymentMethodMapper } from '@data/data/adapters/payment-method/payment-method.mapper';
import { CreateOrderRenewalPackageDto, CreateOrderRenewalPackageRequestDto, CreateOrderRenewalPackageResponseDto } from '@data/data/models/create-order.dto';
import { OrderStatusResponseDto, OrderResponseDto } from '@data/data/models/order-status.dto';
import { PaymentMethodsResponseDto } from '@data/data/models/payment-method.dto';
import { PaymentSummaryParamsDto, PaymentSummaryDataDto, PaymentSummaryRespDto } from '@data/data/models/payment-summary.dto';
import { SendEmailResponseDto } from '@data/data/models/send-invoice.dto';
import { OrderEntity } from '@data/domain/order-detail.entity';
import { PaymentMethod } from '@data/domain/payment-method.entity';
import { PaymentRepository } from '@data/repositories/payment.repository';
import { environment } from '@environments/environment';
import { HttpService } from '@shared/services.http';
import { Observable, map, catchError, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class PaymentAdapter extends PaymentRepository {
    http: HttpService = inject(HttpService);

    orderDetailMapper: OrderDetailMapper = new OrderDetailMapper();
    paymentMethodAdapter = new PaymentMethodMapper();

    paymentMethod(): Observable<PaymentMethod[]> {
        return this.http
            .get<PaymentMethodsResponseDto, null>(
                `${environment.serviceApi}v1/payments/echo/payment_method`
            )
            .pipe(
                map(this.paymentMethodAdapter.mapFrom),
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => error.error);
                })
            );
    }

    createOrder(args: CreateOrderRenewalPackageRequestDto): Observable<CreateOrderRenewalPackageDto> {
        return this.http.post<CreateOrderRenewalPackageResponseDto, CreateOrderRenewalPackageRequestDto>(`${environment.serviceApi}v1/renewal-contract/create-order`, args)
            .pipe(
                map((resp: CreateOrderRenewalPackageResponseDto) => resp.data),
                catchError((error: HttpErrorResponse) => throwError(() => error.error))
            );
    }

    paymentSummary(
        params: PaymentSummaryParamsDto
    ): Observable<PaymentSummaryDataDto> {
        return this.http
            .get<PaymentSummaryRespDto, null>(
                `${environment.serviceApi}v1/renewal-contract/payment-summary/${params.bid}`
            )
            .pipe(
                map((item: PaymentSummaryRespDto) => item.data),
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => error.error);
                })
            );
    }

    OrderDetail(orderId: string): Observable<OrderEntity> {
        return this.http
            .get<OrderStatusResponseDto, null>(
                `${environment.serviceApi}v1/renewal-contract/detail-order/${orderId}`
            )
            .pipe(map(this.orderDetailMapper.mapFromOrderStatus));
        // return this.http.get<OrderStatusResponseDto, null>('https://70158383-d7da-4388-8be7-ed2decf33d25.mock.pstmn.io/order-detail').pipe(map(this.orderDetailMapper.mapFromOrderStatus));
    }

    Order(orderId: string): Observable<OrderEntity> {
        return this.http
            .get<OrderResponseDto, null>(
                `${environment.serviceApi}v1/renewal-contract/get-order/${orderId}`
            )
            .pipe(map(this.orderDetailMapper.mapFromOrder));
        // return this.http.get<OrderResponseDto, null>('https://70158383-d7da-4388-8be7-ed2decf33d25.mock.pstmn.io/order-status').pipe(map(this.orderDetailMapper.mapFromOrder));
    }

    SendInvoiceToEmail(payload: { email: string; orderId: string; }): Observable<{ transactionId: string; }> {
        return this.http.post<SendEmailResponseDto, { email: string; orderId: string; }>(`${environment.serviceApi}email/v1/renewal-contract/send-invoice`, payload).pipe(map(this.orderDetailMapper.mapFromEmailResponse));
    }

}